module.exports = __webpack_public_path__ + "img/寻人区.ee621d09.png";